(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["steam_banner"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('hemiks-banner-slider-v3')) {
  customElements.define('hemiks-banner-slider-v3', class extends HTMLElement {
    connectedCallback() {
      this.readyObserver = new MutationObserver(() => this.init());
      this.readyObserver.observe(this, {childList: true, subtree: true});
      this.init();
    }
    init() {
      if (this.initialized || !this.querySelector('[data-carousel-ready]')) return;
      this.readyObserver.disconnect();
      this.initialized = true;
      this.track = this.querySelector('.hemiks-tech-banners__track');
      this.slides = Array.from(this.track.children).filter(el => el.classList.contains('hemiks-tech-banners__slide'));
      this.dots = Array.from(this.querySelectorAll('[data-slide]'));
      this.count = this.slides.length;
      if (this.count < 2) return;
      this.setAttribute('data-multiple', '');
      this.tabIndex = 0;
      this.pos = 1;
      this.pauseUntil = 0;
      this.listeners = [];
      const clone = slide => {
        const copy = slide.cloneNode(true);
        copy.setAttribute('data-carousel-clone', '');
        copy.setAttribute('aria-hidden', 'true');
        copy.querySelectorAll('[id]').forEach(el => el.removeAttribute('id'));
        return copy;
      };
      this.track.prepend(clone(this.slides[this.count - 1]));
      this.track.append(clone(this.slides[0]));
      const on = (target, name, fn, options) => {
        target.addEventListener(name, fn, options);
        this.listeners.push(() => target.removeEventListener(name, fn, options));
      };
      this.paint(false);
      this.update();
      on(this, 'click', event => {
        const dot = event.target.closest('[data-slide]');
        if (!dot || !this.contains(dot)) return;
        this.manual();
        this.settle();
        this.go(Number(dot.dataset.slide) + 1);
      });
      on(this, 'dragstart', event => event.preventDefault());
      // Native touch events avoid relying on touch-generated mouse/pointer capture.
      on(this, 'touchstart', event => {
        if (event.touches.length !== 1) { this.end(true); return; }
        if (event.target.closest('button')) return;
        const t = event.touches[0];
        this.begin(t.clientX, t.clientY);
      }, {passive: true});
      on(this, 'touchmove', event => {
        if (event.touches.length !== 1) { this.end(true); return; }
        const t = event.touches[0];
        this.move(t.clientX, t.clientY, event);
      }, {passive: false});
      on(this, 'touchend', () => this.end(false));
      on(this, 'touchcancel', () => this.end(true));
      on(this, 'pointerdown', event => {
        if (event.pointerType === 'touch' || !event.isPrimary || event.button !== 0 || event.target.closest('button')) return;
        this.begin(event.clientX, event.clientY);
        this.mouseId = event.pointerId;
        try { this.setPointerCapture(event.pointerId); } catch (_) {}
      });
      on(window, 'pointermove', event => {
        if (event.pointerId === this.mouseId) this.move(event.clientX, event.clientY, event);
      });
      on(window, 'pointerup', event => {
        if (event.pointerId === this.mouseId) { this.mouseId = null; this.end(false); }
      });
      on(window, 'pointercancel', event => {
        if (event.pointerId === this.mouseId) { this.mouseId = null; this.end(true); }
      });
      on(this.track, 'transitionend', event => {
        if (event.target === this.track && event.propertyName === 'transform') this.settle();
      });
      on(this, 'keydown', event => {
        if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        this.manual(); this.settle();
        this.go(this.pos + (event.key === 'ArrowRight' ? 1 : -1));
      });
      on(document, 'visibilitychange', () => { this.end(true); this.schedule(); });
      on(window, 'resize', () => { this.end(true); this.settle(); });
      this.schedule();
    }
    paint(animate, dx = 0) {
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.track.style.transition = animate && !reduced ? 'transform 420ms cubic-bezier(.22,.61,.36,1)' : 'none';
      this.track.style.transform = `translate3d(calc(${-this.pos * 100}% + ${dx}px), 0, 0)`;
    }
    update() {
      this.index = (this.pos - 1 + this.count) % this.count;
      this.dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === this.index)));
      this.slides.forEach((slide, i) => slide.setAttribute('aria-hidden', String(i !== this.index)));
    }
    settle() {
      clearTimeout(this.transitionTimer);
      if (this.pos === 0) this.pos = this.count;
      if (this.pos === this.count + 1) this.pos = 1;
      this.paint(false);
      this.update();
    }
    go(pos) {
      void this.track.offsetWidth;
      this.pos = pos;
      this.paint(true);
      this.update();
      clearTimeout(this.transitionTimer);
      this.transitionTimer = setTimeout(() => this.settle(), 480);
      this.schedule();
    }
    manual() { this.pauseUntil = Date.now() + 8000; clearTimeout(this.timer); }
    begin(x, y) {
      this.manual();
      this.settle();
      this.gesture = {x, y, dx: 0, axis: null, time: Date.now()};
    }
    move(x, y, event) {
      const g = this.gesture;
      if (!g) return;
      const dx = x - g.x, dy = y - g.y;
      if (!g.axis && Math.max(Math.abs(dx), Math.abs(dy)) > 7) g.axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
      if (g.axis !== 'x') return;
      if (event.cancelable) event.preventDefault();
      g.dx = Math.max(-this.clientWidth, Math.min(this.clientWidth, dx));
      this.paint(false, g.dx);
    }
    end(cancelled) {
      const g = this.gesture;
      if (!g) return;
      this.gesture = null;
      const distance = Math.abs(g.dx);
      const quick = distance > 24 && Date.now() - g.time < 300;
      const change = !cancelled && g.axis === 'x' && (distance > Math.min(80, this.clientWidth * .18) || quick);
      this.pauseUntil = Date.now() + 8000;
      // Flush the drag position before animating to the nearest slide.
      void this.track.offsetWidth;
      this.go(this.pos + (change ? (g.dx < 0 ? 1 : -1) : 0));
    }
    schedule() {
      clearTimeout(this.timer);
      if (!this.isConnected || document.hidden || this.gesture || this.count < 2) return;
      this.timer = setTimeout(() => { this.settle(); void this.track.offsetWidth; this.go(this.pos + 1); }, Math.max(5000, this.pauseUntil - Date.now()));
    }
    disconnectedCallback() {
      clearTimeout(this.timer); clearTimeout(this.transitionTimer);
      if (this.readyObserver) this.readyObserver.disconnect();
      (this.listeners || []).forEach(remove => remove());
      this.querySelectorAll('[data-carousel-clone]').forEach(el => el.remove());
      if (this.track) { this.track.style.transform = ''; this.track.style.transition = ''; }
      this.gesture = null; this.mouseId = null; this.initialized = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
